import styles from "./styles.css"
import iconInfo from "../../../../../assets/svg/fixed-voice-info.svg"
import iconError from "../../../../../assets/svg/fixed_voice_error.svg"
import iconCloseInfo from "../../../../../assets/svg/fixed_voice_info_close.svg"
import React, { useState } from "react"
import PropTypes from "prop-types"

const CardInfo = ({ isDanger, children, hasClose }) => {
  const [show, setShow] = useState(true)

  return (
    <div>
      {show && (
        <div
          className={`${styles.container_card} ${
            isDanger ? styles.danger : styles.info
          }`}
        >
          <div className={styles.icon}>
            {isDanger ? (
              <img src={iconError} alt={"iconError"} />
            ) : (
              <img src={iconInfo} alt={"icon info"} />
            )}
          </div>
          <div>{children}</div>
          {hasClose && (
            <div className={styles.icon_close}>
              <img
                src={iconCloseInfo}
                onClick={() => setShow(false)}
                alt={"icon close info"}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

CardInfo.propTypes = {
  isDanger: PropTypes.bool,
  children: PropTypes.node,
  hasClose: PropTypes.bool
}

export default CardInfo



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/CardInfo/index.js